import React, { Component } from 'react';
import Slider from "react-slick";
import { connect } from 'react-redux';
 
import Auxiliary from '../../HOC/Auxiliary/Auxiliary'; 
import GetInTouch from './Sections/GetInTouch';
import Offer from './Sections/Offer';
import Services from './Sections/Services';
import Excellence from './Sections/Excellence';
import Testimonials from './Sections/Testimonials';
import Cases from './Sections/Cases'
import SliderSettings from "../../Configs/Slider.json";
import * as actions from '../../store/actions';
import { Link } from 'react-router-dom';

 
class Countries extends Component{
    componentDidMount(){
        this.props.onFetchImages()
    }
    render(){       
        return(
            <Auxiliary>
                <div   className="bgSlider">
                    <Slider {...SliderSettings}>
                        {
                            this.props.bannerImages.map((data, index)=>{
                                return(
                                   <div key={index}>
                                      <div  className="bgSlider-wrap" style={{backgroundImage: `url(${ data.image })`}}>
                                        <div className="mx-width">
                                           <div className="banner-text">
                                                <h1 className="bg-text1 mb-1"><span className="text-color2">Explore,</span></h1>
                                                <h1 className="bg-text1 mb-1">Select & Apply</h1>
                                                <h2 className="heading2 fw-sb mb-1">with unlimited courses and possibilities.</h2>
                                                <div className="mt-2">
                                                   <Link to="/services/ielts" type="button" className="btn btn-explore">Explore</Link>
                                                </div>
                                           </div>
                                        </div>
                                     </div>
                                   </div>
                                )
                            })
                        }
                    </Slider>
                </div>
                <GetInTouch />
                <Offer />
                <Services />
                <Excellence />
                <Testimonials />
                <Cases />
            </Auxiliary>
        )
    }
}
const mapStateToprops = state =>{
    return{
       bannerImages :  state.bannerImages
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
      onFetchImages: () => dispatch(actions.fetchImages())
    };
  };
export default connect(mapStateToprops, mapDispatchToProps)(Countries);